import { render, staticRenderFns } from "./2introduce.vue?vue&type=template&id=9d8df3ea&scoped=true&"
import script from "./2introduce.vue?vue&type=script&lang=js&"
export * from "./2introduce.vue?vue&type=script&lang=js&"
import style0 from "./2introduce.vue?vue&type=style&index=0&id=9d8df3ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8df3ea",
  null
  
)

export default component.exports